package de.xtl.retroguide

import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Canvas
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.rotate
import androidx.compose.ui.unit.dp

@Composable
internal fun CelebrationConfetti(modifier: Modifier = Modifier) {
    val progress = remember { Animatable(0f) }
    LaunchedEffect(Unit) { progress.animateTo(1f, tween(durationMillis = 1_800)) }

    Canvas(modifier) {
        val colors = listOf(Color(0xFFE91E63), Color(0xFFFFC107), Color(0xFF4CAF50), Color(0xFF2196F3))
        val width = 8.dp.toPx()
        val height = 14.dp.toPx()
        repeat(16) { index ->
            val elapsed = progress.value
            val x = size.width / 2 + (((index % 7) - 3) * size.width / 7) * elapsed
            val y = size.height * .2f + size.height * (.4f + (index % 5) * .12f) * elapsed
            rotate(index * 25f + elapsed * 720f, Offset(x, y)) {
                drawRoundRect(
                    color = colors[index % colors.size],
                    topLeft = Offset(x - width / 2, y - height / 2),
                    size = Size(width, height),
                    cornerRadius = CornerRadius(width / 4),
                    alpha = ((1f - elapsed) / .2f).coerceIn(0f, 1f),
                )
            }
        }
    }
}
